import React, { useState } from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import Header from './Header/Header';
import Sidebar from './Sidebar/Sidebar';
import Nucleos from './TabelasReferencia/Nucleos/Nucleos';
import Bairros from './TabelasReferencia/Bairros/Bairros';
import Cidades from './TabelasReferencia/Cidades/Cidades';
import Nacionalidades from './TabelasReferencia/Nacionalidades/Nacionalidades';
import Profissoes from './TabelasReferencia/Profissoes/Profissoes';
import SituacaoCadastral from './TabelasReferencia/SituacaoCadastral/SituacaoCadastral';
import SituacaoFuncional from './TabelasReferencia/SituacaoFuncional/SituacaoFuncional';
import SetoresFuncional from './TabelasReferencia/SetoresFuncional/SetoresFuncional';
import Departamentos from './TabelasReferencia/Departamentos/Departamentos';
import GrauDeInstrucao from './TabelasReferencia/GrauDeInstrucao/GrauDeInstrucao';
import TipoEnquadramento from './TabelasReferencia/TipoEnquadramento/TipoEnquadramento';
import ClassificacaoEnquadramento from './TabelasReferencia/ClassificacaoEnquadramento/ClassificacaoEnquadramento';
import OrgaosReferencia from './TabelasReferencia/OrgaosReferencia/OrgaosReferencia';
import UnidadeMedida from './TabelasReferencia/UnidadeMedida/UnidadeMedida';
import OrgaoEspecialidades from './TabelasReferencia/OrgaoEspecialidades/OrgaoEspecialidades';
import Diretrizes from './TabelasReferencia/Diretrizes/Diretrizes';
import Projetos from './TabelasReferencia/Projetos/Projetos';
import DocumentacaoBasica from './TabelasReferencia/DocumentacaoBasica/DocumentacaoBasica';
import DocumentacaoTecnica from './TabelasReferencia/DocumentacaoTecnica/DocumentacaoTecnica';
import TipoLogradouros from './TabelasReferencia/TipoLogradouros/TipoLogradouros';
import AtividadesCNAE from './TabelasReferencia/AtividadesCNAE/AtividadesCNAE';
import InstituicoesFormacao from './TabelasReferencia/InstituicoesFormacao/InstituicoesFormacao';
import TiposDocumentos from './TabelasReferencia/TiposDocumentos/TiposDocumentos';
import StatusProcesso from './TabelasReferencia/StatusProcesso/StatusProcesso';
import PrazosValidacao from './TabelasReferencia/PrazosValidacao/PrazosValidacao';
import TiposLicenca from './TabelasReferencia/TiposLicenca/TiposLicenca';
import PareamentoLeis from './TabelasReferencia/PareamentoLeis/PareamentoLeis';
import GrauPoluidor from './TabelasReferencia/GrauPoluidor/GrauPoluidor';
import AreaEmpreendimento from './TabelasReferencia/AreaEmpreendimento/AreaEmpreendimento';
import InvestimentoUFM from './TabelasReferencia/InvestimentoUFM/InvestimentoUFM';
import TextoPadrao from './TabelasReferencia/TextoPadrao/TextoPadrao';
import QuadroFuncional from './TabelasReferencia/QuadroFuncional/QuadroFuncional';
import FaixaLicenciamento from './TabelasReferencia/FaixaLicenciamento/FaixaLicenciamento';
import Indexadores from './TabelasReferencia/Indexadores/Indexadores';
import Contribuintes from './TabelasReferencia/Contribuintes/Contribuintes';
import Usuarios from './Usuarios/Usuarios';
import DadosOrgao from './DadosOrgao/DadosOrgao';
import Home from './Home/Home';
import './Dashboard.css';

const Dashboard = ({ user, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Placeholder para componentes futuros
  const Placeholder = ({ title }) => (
    <div>
      <h2>{title}</h2>
      <p>Esta página está em construção.</p>
    </div>
  );

  return (
    <div className="dashboard-container">
      <Header 
        user={user} 
        onLogout={onLogout} 
        toggleSidebar={toggleSidebar} 
      />
      <div className="dashboard-body">
        <Sidebar isOpen={sidebarOpen} onLogout={onLogout} />
        <main className={`main-content ${sidebarOpen ? 'open' : 'closed'}`}>
          <Routes>
            <Route index element={<Home />} />
            <Route path="nucleos" element={<Nucleos />} />
            <Route path="bairros" element={<Bairros />} />
            <Route path="cidades" element={<Cidades />} />
            
            {/* Rotas de placeholder para os outros itens do menu */}
            <Route path="logradouros" element={<Placeholder title="Logradouros" />} />
            <Route path="paises" element={<Placeholder title="Países" />} />
            <Route path="nacionalidades" element={<Nacionalidades />} />
            <Route path="profissoes" element={<Profissoes />} />
            <Route path="situacao-cadastral" element={<SituacaoCadastral />} />
            <Route path="situacao-funcional" element={<SituacaoFuncional />} />
            <Route path="setores-funcional" element={<SetoresFuncional />} />
            <Route path="departamentos" element={<Departamentos />} />
            <Route path="grau-de-instrucao" element={<GrauDeInstrucao />} />
            <Route path="tipo-de-enquadramento" element={<TipoEnquadramento />} />
            <Route path="classificacao-enquadramento" element={<ClassificacaoEnquadramento />} />
            <Route path="orgaos-referencia" element={<OrgaosReferencia />} />
            <Route path="unidade-medida" element={<UnidadeMedida />} />
            <Route path="orgao-especialidades" element={<OrgaoEspecialidades />} />
            <Route path="diretrizes" element={<Diretrizes />} />
            <Route path="projetos" element={<Projetos />} />
            <Route path="documentacao-basica" element={<DocumentacaoBasica />} />
            <Route path="documentacao-tecnica" element={<DocumentacaoTecnica />} />
            <Route path="tipo-logradouros" element={<TipoLogradouros />} />
            <Route path="atividades-cnae" element={<AtividadesCNAE />} />
            <Route path="instituicoes-formacao" element={<InstituicoesFormacao />} />
            <Route path="tipos-documentos" element={<TiposDocumentos />} />
            <Route path="status-processo" element={<StatusProcesso />} />
            <Route path="prazos-validacao" element={<PrazosValidacao />} />
            <Route path="tipos-licenca" element={<TiposLicenca />} />
            <Route path="pareamento-leis" element={<PareamentoLeis />} />
            <Route path="grau-poluidor" element={<GrauPoluidor />} />
            <Route path="area-empreendimento" element={<AreaEmpreendimento />} />
            <Route path="investimento-ufm" element={<InvestimentoUFM />} />
            <Route path="texto-padrao" element={<TextoPadrao />} />
            <Route path="quadro-funcional" element={<QuadroFuncional />} />
            <Route path="faixa-licenciamento" element={<FaixaLicenciamento />} />
            <Route path="indexadores" element={<Indexadores />} />
            <Route path="contribuintes" element={<Contribuintes />} />
            <Route path="roteiro-orientativo" element={<Placeholder title="Roteiro Orientativo" />} />
            <Route path="tecnicos-ambientais" element={<Placeholder title="Técnicos Ambientais" />} />
            <Route path="atividade-secundaria" element={<Placeholder title="Atividade Secundária" />} />

            {/* Trâmite */}
            <Route path="abertura-processo" element={<Placeholder title="Abertura de Processo" />} />
            <Route path="protocolo-padrao" element={<Placeholder title="Protocolo Padrão" />} />
            <Route path="enquadramento" element={<Placeholder title="Enquadramento" />} />
            <Route path="dam" element={<Placeholder title="DAM" />} />

            {/* Consultas */}
            <Route path="consulta-roteiro" element={<Placeholder title="Consulta de Roteiro Orientativo" />} />
            <Route path="consulta-processos" element={<Placeholder title="Consulta de Processos" />} />

            {/* Impressões */}
            <Route path="impressao-processo" element={<Placeholder title="Impressão de Processo" />} />
            <Route path="impressao-licenca" element={<Placeholder title="Impressão de Licença" />} />

            {/* Contratos */}
            <Route path="gerenciar-contratos" element={<Placeholder title="Gerenciar Contratos" />} />

            {/* Utilidades */}
            <Route path="dados-orgao" element={<DadosOrgao />} />
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="niveis-acesso" element={<Placeholder title="Níveis de Acesso" />} />

          </Routes>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
